// extracted by mini-css-extract-plugin
export default {"sheetContainer":"ParsedDataDisplay_sheetContainer__WnBTc","tableWrapper":"ParsedDataDisplay_tableWrapper__ecYHx","dataTable":"ParsedDataDisplay_dataTable__guITH"};